import React, { useState } from 'react';
import { ModuleDrawerContext, ModuleDrawerState } from '../contexts/ModuleDrawerContext';

export const ModuleDrawerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [moduleDrawerState, setModuleDrawerState] = useState<ModuleDrawerState>(null);

  return <ModuleDrawerContext.Provider value={{ moduleDrawerState, setModuleDrawerState }}>{children}</ModuleDrawerContext.Provider>;
};
